import React, { SyntheticEvent } from "react";

//MUI
import { Add } from "@mui/icons-material";

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";
import { prepareCoordinatesForDisplay } from "@/lib/olHelpers";


type InfoPaneAddActionButtonProps = {
  initialCoordinates?: number[];
  label?: string | undefined;
  onAdd: (coord: number[] | undefined, label: string) => void;
}

const InfoPaneAddActionButton = (props: InfoPaneAddActionButtonProps) => {

  const { initialCoordinates, label, onAdd } = props;

  const handleClick = (evt: SyntheticEvent) => {

    const displayCoordinates = initialCoordinates ? prepareCoordinatesForDisplay(initialCoordinates) : null;
    const displayLabel = label ? label
      : displayCoordinates ? `${displayCoordinates[1]}N ${displayCoordinates[0]}E`
        : "?";

    onAdd(initialCoordinates, displayLabel);
  }

  return (
    <InfoPaneActionButton
      title_ttoken={"buttons.add"}
      icon={<Add color="primary" fontSize="large"></Add>}
      onClick={handleClick}
    />
  );
}

export default InfoPaneAddActionButton;
